// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class PdfMath {
	static toMm(point: number) {
		return point * (25.4 / 72.27);
	}
}
